import { DataQueryParams } from 'common/src/query-params/DataQueryParams';
import { IPage, IWorkOrder } from 'common/src/types/interfaces';

import { API_BASE_PATHS } from 'portal/src/api/constants';
import formatQueryParams from 'portal/src/api/formatQueryParams';
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from 'portal/src/api/requestTypes';

export const getWorkOrders = async (
  params?: DataQueryParams,
): Promise<IPage<IWorkOrder>> =>
  await getRequest(API_BASE_PATHS.WORK_ORDERS, formatQueryParams(params));

export const getWorkOrder = async (id: string): Promise<IWorkOrder> =>
  await getRequest(`${API_BASE_PATHS.WORK_ORDERS}/${id}`);

export const addWorkOrder = async (body: any) =>
  await postRequest(API_BASE_PATHS.WORK_ORDERS, {}, body);

export const updateWorkOrder = async (id: string, body: any) =>
  await patchRequest(`${API_BASE_PATHS.WORK_ORDERS}/${id}`, {}, body);

export const deleteWorkOrder = async (id: string): Promise<void> =>
  await deleteRequest(`${API_BASE_PATHS.WORK_ORDERS}/${id}`, {});
